import SpielService from "@/services/data/spielService";

export default class AttestTargetDateService {
    static getTargetDates(spielTag, dates, saison){
        if ( !spielTag ) { return '' }
        const altersklasse = SpielService.getAltersklasse(
            dates.akHJ,
            dates.akJahr,
            saison.id);
        const dateParts = spielTag.split('-');
        const u23Year = parseInt(dateParts[0]) + 2;
        const u21Year = parseInt(dateParts[0]) + 1;
        const newMonth = dateParts[2] !== '01' ? dateParts[1] : AttestTargetDateService.getPreviousMonth(dateParts[1]);
        const newDay = dateParts[2] !== '01' ? ('00' + (parseInt(dateParts[2])-1)).slice(-2) :
                                                 AttestTargetDateService.getPreviousDay(dateParts[1]);
        const targetU23AndUp = u23Year + '-' + newMonth + '-' + newDay;
        const targetU21AndDown = u21Year + '-' + newMonth + '-' + newDay;
        switch (altersklasse) {
            case 'U10':
            case 'U15':
            case 'U19':
                return targetU21AndDown;
            default:
                return targetU23AndUp;

        }
        /*return {
            targetU23AndUp: targetU23AndUp,
            targetU21AndDown: targetU21AndDown,
        }*/
    }
    static getPreviousMonth(month){
        switch (month) {
            case '01': return '12';
            case '02': return '01';
            case '03': return '02';
            case '04': return '03';
            case '05': return '04';
            case '06': return '05';
            case '07': return '06';
            case '08': return '07';
            case '09': return '08';
            case '10': return '09';
            case '11': return '10';
            case '12': return '11';
        }
        return month;
    }

    static getPreviousDay(month){
        switch (month) {
            case '01':
            case '02':
            case '04':
            case '06':
            case '08':
            case '09':
            case '11':
                return '31';
            case '05':
            case '07':
            case '10':
            case '12':
                return '30';
            case '03':
                return '28';
        }
        return '31';
    }
}